import React from 'react';
import { Button } from 'react-bootstrap';

import { useNavigation } from '../../../common/navigation';

interface RegisterNumberingButtonProps {
  facilityId: string;
}

export const RegisterNumberingButton: React.FC<
  RegisterNumberingButtonProps
> = ({ facilityId }) => {
  const nav = useNavigation();
  return (
    <Button
      size="sm"
      variant="outline-primary"
      onClick={(e: React.MouseEvent) => {
        e.stopPropagation();
        void nav.registerNumberingAdmin(facilityId);
      }}
    >
      Numeracja
    </Button>
  );
};
